import { DAP_BRAND_URLS } from '@dap/common/consts';
import { RecognizedBrands } from '@dap/common/types';

export const brandKeyFromCurrentUrl =
  DAP_BRAND_URLS &&
  (Object.entries(DAP_BRAND_URLS).find(([_, dapBrandUrls]) =>
    dapBrandUrls.some((brandUrl) => window.location.href.includes(brandUrl))
  )?.[0] as RecognizedBrands | undefined);
